<template>
    <form method="post" @submit.prevent="submit">
        <div class="form-group">
            <label>Your Name</label>
            <input class="form-control" name="name" style="width: 300px;" required v-model="name"></input>
        </div>

        <div class="form-group">
            <label>Title</label>
            <input class="form-control" name="title" style="width: 300px;" required v-model="title"></input>
        </div>

        <div class="form-check">
            <input type="checkbox" class="form-check-input" name="agreed" id="exampleCheck1" required>
            <label class="form-check-label" for="exampleCheck1">I agree to Truckersreport Terms and Conditions</label>
        </div>

        <button class="btn btn-lg btn-primary" style="margin-top: 10px;">
            <i v-if="loading" class="fa fa-fw fa-spinner fa-spin"></i>
            {{ text }}
        </button>
    </form>
</template>

<script>
export default {
    props: [
        'identifier'
    ],
    data() {
        return {
            name: '',
            title: '',
            loading: false,
            text: 'Sign Sales Agreement',
            pusher: {
                public: null,
            },
        }
    },
    methods: {
        submit() {
            this.loading = true;
            this.text = 'Signing';

            this.sign();
        },
        sign() {
            axios.post(url(`proposal/${this.identifier}/sign`), {
                name: this.name,
                title: this.title,
                agreed: true
            }).catch(() => {
                window.location.href = url(`proposal/${this.identifier}`);
            });
        }
    },
    created() {
        this.pusher.public = Echo.channel(`public`);
        this.pusher.public.listen('.portal-ready', (event) => {
            if (event.identifier == this.identifier) {
                this.loading = false;
                this.text = 'Signed';
                window.location.href = event.redirect_url;
            }
        });
    },
    beforeDestroy() {
        this.pusher.all_users.stopListening('.portal-ready');
    }
}
</script>